export const meta = { id: 'O20', slug: 'jornada-vs-formacao', title: 'Jornada x Formação: quando utilizar?', description: 'Diferencie o papel da Jornada e da Formação na organização do desenvolvimento.', profile: 'owner', category: 'jornadas', type: 'concept', status: 'published', order: 500, keywords: ['jornada','formação','diferença','trilha','programa'], previous: 'O19', next: 'O21', related: ['O17','O21','A06'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Jornada x Formação: quando utilizar?

**Jornada** organiza um caminho de desenvolvimento. **Formação** estrutura um programa com Etapas, Componentes, regras, participantes e conclusão.

## Use Jornada quando

Você precisa organizar experiências em um percurso e orientar o participante sobre o que vem depois.

## Use Formação quando

Você precisa de uma estrutura formal com Etapas, Componentes, obrigatoriedade, pré-requisitos, participantes e regras de conclusão.

<Callout type="concept">Jornada e Formação não competem. Elas podem trabalhar juntas quando a Formação faz parte de um percurso maior.</Callout>
